import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		group_id: 2,
		// resUrl: 'http://fast.jukest.com', //测试环境：用于打开图片
		// resUrl:'https://platform.jukest.cn', //正式环境：用于打开图片
		
		
		/*-- 正式环境 --*/
		resUrl: 'https://platform.jukest.cn/',
		resUrlTB:'https://system.jukest.cn/',//淘票票
		imgUrlTB: 'https://gw.alicdn.com/tfscom/', //淘票票--图片域名前缀

		userInfo: {
			token: '',
			avatar: '',
			nickname: ''
		},
		lat: '',
		lng: '',
		selCityInfo:{
			region_name:'',//城市名
			city_code:''
		},
		selCineInfo: { //选择的影院信息
			id: '',
			name: '',
			hall_name:'',
			addr: '',
			tel: ''
		},
		orderId: '', //订单id
		idCards: [ //观影人信息【疫情身份验证】
			// {
			//   id:'',
			//   type:0,
			//   name:'',
			//   idCard:'',
			//   tel:''
			// }
		],
	},
	mutations: {
		updateLocationInfo: function(state, obj) {
			localStorage.locationInfo = JSON.stringify(obj);
			state.lat = obj.lat;
			state.lng = obj.lng;
			state.selCityInfo.region_name = obj.region_name;
			state.selCityInfo.city_code = obj.city_code;
		},
		//退出登录
		logout: function(state) {
			state.token = '';
			state.userInfo = {};
			delete localStorage.userInfo;
			state.idCards = [];
			delete localStorage.idCards;
			state.orderId = '';
			delete localStorage.orderId;
		},
		updateCineInfo: function(state, obj) {
			localStorage.selCineInfo = JSON.stringify(obj);
			state.selCineInfo = obj;
		},
		updateUserInfo: function(state, obj) {
			localStorage.userInfo = JSON.stringify(obj);
			state.userInfo = obj;
		},
		updateOrderId: function(state, obj) {
			localStorage.orderId = JSON.stringify(obj);
			state.orderId = obj.orderId;
		},
		updateIdCards:function(state,obj){
			localStorage.idCards = JSON.stringify(obj);
			state.idCards = obj;
		}
	},
	actions: {

	}
})
